import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { formatTimeSpan } from '@/lib/formatters'
import type { TimeToQuoting } from '@/models/quoteAnalytics'

const spanOrDash = (seconds: number | null) => (seconds === null ? '—' : formatTimeSpan(seconds))

export function TimeToQuotingCard({ timeToQuoting }: { timeToQuoting: TimeToQuoting }) {
  const stats = [
    { label: 'Median time on page', value: spanOrDash(timeToQuoting.medianTimeOnPageSeconds) },
    { label: '90th percentile', value: spanOrDash(timeToQuoting.p90TimeOnPageSeconds) },
    { label: 'Median elapsed time', value: spanOrDash(timeToQuoting.medianElapsedSeconds) },
    { label: 'Applications', value: String(timeToQuoting.applications) },
  ]

  return (
    <Card>
      <CardHeader>
        <CardTitle>Time to quoting</CardTitle>
        <CardDescription>
          From a customer&apos;s first question in the application to their first priced quote on screen. Time
          on page skips any stretch the tab was hidden or untouched for over 2 minutes; elapsed time counts it
          all. Vendor and fleet size filters don&apos;t apply.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {stats.map(({ label, value }) => (
          <div key={label}>
            <div className="text-sm text-neutral-500">{label}</div>
            <div className="text-2xl font-semibold tabular-nums">{value}</div>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
